import moment from 'moment';

var controller = function () {
  var initialState = {
    last_day: false,
    last_week: false,
    last_month: false,
    all_time: false,
    custom_date: false
  };
  var search = null;
  var state = {};

  /**
   * If there is already a time filter active when initializing this service,
   * it sets the custom_date as active. This is relevant when refreshing the page,
   * entering the page with pre-defined url params, or if time filters in alerts are
   * enabled.
   *
   * @returns {undefined}
   */
  var setPreviousTimeFilter = function() {
    if (search.filter.updated_since.isActive()) {
      state.custom_date = true;
    }
  };

  /**
   * Sets searchJs updated_since filter value to a date. Sets the local state variable
   * reflect the current time filter, e.g. last_week. Optional: Calls a new search.
   *
   * @param {string} key - key for pre-defined time spans e.g. last_week
   * @param {boolean} notifyParamChange - if true, makes new search after setting the filter.
   * @returns {undefined}
   */
  var setDate = function(key, notifyParamChange) {
    if (!search) {
      throw new Error('initialize date_filter.service before using setDate()');
    }

    if (state[key] && key !== 'custom_date') {
      return;
    }

    // Copy object, without creating a memory reference.
    state = JSON.parse(JSON.stringify(initialState));

    switch (key) {
      case 'last_day':
        search.filter.updated_since.setValue(moment().add(-1, 'days').toISOString());
        state.last_day = true;
        break;
      case 'last_week':
        search.filter.updated_since.setValue(moment().add(-1, 'weeks').toISOString());
        state.last_week = true;
        break;
      case 'last_month':
        search.filter.updated_since.setValue(moment().add(-1, 'months').toISOString());
        state.last_month = true;
        break;
      case 'custom_date':
        // Custom date is directly set by the date picker in searchJS.
        // It needs however, to be converted to ISO format to work.
        search.filter.updated_since.setValue(
          search.filter.updated_since.value.toISOString()
        );
        state.custom_date = true;
        break;
      case 'all_time':
        search.filter.updated_since.value = null;
        state.all_time = true;
        break;
      default:
        // Any other value, such as 'clear'
        search.filter.updated_since.value = null;
        state = {};
        break;
    }

    if (notifyParamChange) {
      search.notifyParamChange();
    }
  };

  /**
   * If the time filter is already active, it resets the filter. Else, it adds the time filter
   * Allows for toggling time filters in the advanced filter menu
   *
   * @param {string} key - key for pre-defined time spans e.g. last_week
   * @param {boolean} notifyParamChange - if true, makes new search after setting the filter
   * @returns {undefined}
   */
  var toggleDate = function(key, notifyParamChange) {
    if (state[key]) {
      setDate(null, notifyParamChange);
      return;
    }
    setDate(key, notifyParamChange);
  };

  /**
   * If any time filters in the state are active, return and do nothing.
   * Else, set the given time filter key to active. This can be used for setting
   * a initial time filter after making a text query.
   *
   * @param {string} key - key for pre-defined time spans e.g. last_week
   * @param {boolean} notifyParamChange - if true, makes new search after setting the filter
   * @returns {undefined}
   */
  var setDateIfNoDate = function(key, notifyParamChange) {
    for (var timeFilter in state) {
      if (timeFilter) {
        return;
      }
    }
    setDate(key, notifyParamChange);
  };

  /**
   * Returns the current state of the time filters. This allows us to quickly check if e.g.
   * last_month is active by calling getState()[last_month']
   *
   * @returns {object} state - List of all filter options and its state
   */
  var getState = function() {
    return state;
  };

  /**
   * Initializes the service
   *
   * @param {object} searchJs - an active instance of searchJs in the parent app
   * @returns {undefined}
   */
  var init = function(searchJs) {
    if (!searchJs) {
      throw new Error('cant initialize date_filter.service without searchJS');
    }
    search = searchJs;
    setPreviousTimeFilter();
  };

  return {
    init: init,
    setDate: setDate,
    getState: getState,
    toggleDate: toggleDate,
    setDateIfNoDate: setDateIfNoDate
  };
};

angular
  .module('fundingSearchApp.services.dateFilterService', [])
  .service('dateFilterService', controller);
